<template>
  <el-tag
    v-if="info.type_contract"
    class="text-left"
    style="height: auto"
    :type="info.contract_end_date ? 'warning' : 'info'"
  >
    <translate-text keyTranslate="common_words.type" />:
    {{ info.type_contract.name }}
    <br />
    <translate-text keyTranslate="common_words.beginning" />:
    <template v-if="info.contract_start_date">
      {{ info.contract_start_date }}
    </template>
    <template v-else>
      <translate-text keyTranslate="common_words.no_assignment" />
    </template>
    <template v-if="info.contract_end_date">
      <br />
      <translate-text keyTranslate="common_words.end" />:
      {{ info.contract_end_date }}
    </template>
  </el-tag>
</template>
<script>
export default {
  name: 'contract-info',
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
};
</script>
